import * as analytics from 'analytics/Analytics';
import {NAV_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';

export function trackOpenedRelevantTemplatesTab(metadata: {
  schemaId: string;
  schemaType: string;
  isAdmin: string;
}): void {
  analytics.trackEvent(NAV_ANALYTICS_ACTIONS.OPENED_RELEVANT_TEMPLATES_TAB, metadata);
}

export function trackOpenedRelevantTemplate(metadata: {
  schemaId: string;
  schemaType: string;
  isAdmin: string;
}): void {
  analytics.trackEvent(NAV_ANALYTICS_ACTIONS.OPENED_RELEVANT_OBJECT, {
    itemType: 'template',
    ...metadata,
  });
}

export function trackOpenedRelevantTemplatesAdminHelp(metadata: {
  schemaId: string;
  schemaType: string;
  totalInaccessible: number;
  isAdmin: string;
}): void {
  analytics.trackEvent(NAV_ANALYTICS_ACTIONS.OPENED_RELEVANT_TEMPLATES_ADMIN_HELP, metadata);
}
